/* React */
import React from "react";

/* Ionic */
import { IonIcon } from "@ionic/react";

/* Stylesheet */
import styles from "./ToolbarContainer.module.scss";

/* Interfaces */
interface ToolbarContainerProps {
  icon?: string;
  label: string;
}

const ToolbarContainer: React.FC<ToolbarContainerProps> = ({
  icon,
  label,
}) => {
  return (
    <div className={styles.toolbar_container}>
      {icon ? (
        <div className={styles.icon_container}>
          <IonIcon className={styles.icon} icon={icon} />
        </div>
      ) : undefined}
      <div className={styles.label}>{label}</div>
    </div>
  );
};

export default ToolbarContainer;
